import { Ribbon } from '@/data/types/Product';

export const extractNumberFromString = (input: string) => {
	const match = input.match(/\d+/);
	return match ? parseInt(match[0], 10) : 0;
};

const extractOfferPercentage = (ribbons: Ribbon[]) => {
	const ribbonDpt = ribbons.find((ribbon) => ribbon.identifier === 'DPV_Oferta');
	if (!ribbonDpt) {
		return {
			percentage: 0,
			baseHundredPercentage: 0,
		};
	}
	const offer = extractNumberFromString(ribbonDpt.value);

	return {
		percentage: offer,
		baseHundredPercentage: offer / 100,
		additionalOffer: !!ribbonDpt,
	};
};

export const calculateProductPrices = ({
	list,
	offer,
	ribbons,
}: {
	list: number;
	offer: number;
	ribbons: Ribbon[];
}) => {
	const offerPercentage = extractOfferPercentage(ribbons);
	const discount = offer * offerPercentage.baseHundredPercentage;
	const price = offer - discount;

	return {
		priceWithoutOffer: list,
		shouldOffer: offer > 0 && offer !== list,
		price,
		additionalOffer: offerPercentage.additionalOffer,
	};
};
